var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _rect2, _g2, _g3, _g4, _g5, _g6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCarpetStains = function SvgCarpetStains(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 94a1 1 0 011 1v10a1 1 0 01-2 0V95a1 1 0 011-1zm56 0a1 1 0 011 1v10a1 1 0 01-2 0V95a1 1 0 011-1zm-48 1a1 1 0 10-2 0v10a1 1 0 002 0V95zm6-1a1 1 0 011 1v10a1 1 0 01-2 0V95a1 1 0 011-1zm8 1a1 1 0 10-2 0v10a1 1 0 002 0V95zm6-1a1 1 0 011 1v10a1 1 0 01-2 0V95a1 1 0 011-1zm8 1a1 1 0 10-2 0v10a1 1 0 002 0V95zm6-1a1 1 0 011 1v10a1 1 0 01-2 0V95a1 1 0 011-1zm8 1a1 1 0 10-2 0v10a1 1 0 002 0V95z",
    fill: "#332C4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 26H24v14h72V26z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92 24H28v18h64V24z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22H32v76h56V22z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80 22H40v68h40V22z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "carpetStains_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 21,
    width: 42,
    height: 70
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80 22H40v68h40V22z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#carpetStains_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 15c-.397 0-.786.039-1.162.112A1.875 1.875 0 0060.125 14H60a2 2 0 00-1.62 3.172A5.976 5.976 0 0057 21c0 .358.031.709.092 1.05A3.5 3.5 0 0053 25.5v1a3.5 3.5 0 004.092 3.45A6 6 0 0068.2 33.997 6 6 0 0074 28v-.375a5.626 5.626 0 00-5.087-5.6C68.97 21.692 69 21.35 69 21v-.375A5.625 5.625 0 0063.375 15H63zm-9.542 22.064l1.963-2.234a.897.897 0 00-.99-1.431l-2.783 1.047a1.64 1.64 0 101.81 2.618zm-.106-17.482l-2.55-1.53a1.64 1.64 0 112.25-2.25l1.53 2.55a.897.897 0 01-1.23 1.23zM50 32.5v-.094C50 31.63 49.37 31 48.594 31H48.5a1.5 1.5 0 101.5 1.5z",
    fill: "#332C4A"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.774 61.485c.281.281.529.583.742.901a1.875 1.875 0 011.998.425l.089.089a2 2 0 01-1.098 3.389 5.976 5.976 0 01-1.73 3.682c-.254.253-.524.479-.808.677a3.5 3.5 0 01.453 5.333l-.706.707a3.5 3.5 0 01-5.333-.453 6 6 0 01-10.716-4.993 6 6 0 01.139-8.343l.265-.265a5.626 5.626 0 017.557-.362 6.04 6.04 0 01.663-.787l.265-.265a5.625 5.625 0 017.955 0l.265.265zm-8.854 22.35l.191-2.968a.897.897 0 011.712-.313l1.228 2.709a1.64 1.64 0 11-3.131.571zm12.437-12.287l2.885.721a1.64 1.64 0 100-3.183l-2.885.722a.897.897 0 000 1.74zm-6.765 11.504l.066-.066c.55-.55 1.44-.55 1.99 0l.066.066a1.5 1.5 0 11-2.122 0z",
    fill: "#332C4A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 25,
    rx: 6,
    transform: "scale(-1 1) rotate(-30 98.613 120.869)",
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#carpetStains_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.728 77.266l-.032.055a1 1 0 11-.366-1.366l.055.03a.938.938 0 01.343 1.281z",
    fill: "#332C4A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#carpetStains_svg__filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.754 76.812l-.031.054a1 1 0 11-.366-1.366l.054.031a.938.938 0 01.343 1.28z",
    fill: "#332C4A"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#carpetStains_svg__filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.754 70.812l-.031.054a1 1 0 11-.366-1.366l.054.031a.938.938 0 01.343 1.28z",
    fill: "#332C4A"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#carpetStains_svg__filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.754 64.812l-.031.054a1 1 0 11-.366-1.366l.054.031a.938.938 0 01.343 1.28z",
    fill: "#332C4A"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#carpetStains_svg__filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.754 70.812l-.031.054a1 1 0 11-.366-1.366l.054.031a.938.938 0 01.343 1.28z",
    fill: "#332C4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "carpetStains_svg__filter0_d",
    x: 21.83,
    y: 75.821,
    width: 10.023,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "carpetStains_svg__filter1_d",
    x: 28.856,
    y: 75.366,
    width: 10.023,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "carpetStains_svg__filter2_d",
    x: 32.856,
    y: 69.366,
    width: 10.023,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "carpetStains_svg__filter3_d",
    x: 29.856,
    y: 63.366,
    width: 10.023,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "carpetStains_svg__filter4_d",
    x: 25.856,
    y: 69.366,
    width: 10.023,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

export default SvgCarpetStains;